import MainLayout from "@/components/layout/MainLayout.vue";
import Pagination from 'laravel-vue-pagination';
import axios from "axios";
import { mapGetters } from "vuex";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import '../../assets/css/enroll-student-course.css';
import { fetchNotificationCount } from "@/services/common/notification-service";

const convertNumberService = new ConvertNumService();

export default {
    name: "enrollStudentList",

    components: {
        MainLayout,
        Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            classvalue: {
                course_name: "",
            },
            keyword: "",
            classes: {},
            pag_status: false,
            lastPage: "",
            currentPage: "",
            currentDate: ""
        };
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        showNotify(course_id) {
            this.$router.push(
                {
                    name: 'detailVideoCourse',
                    params: { id: course_id }
                }
            )
        },
        notify(teacher_id) {
            // axios.get("student/createNofication", {
            axios.get("my/class/" + this.studentId + "/remind-enroll", {
                params: {
                    teacher_id: teacher_id,
                    student_id: this.studentId
                }
            })
                .then(() => {
                    this.$notification.success("သင်တန်းလျှောက်ထားမှုအောင်မြင်ပါသည်။ သက်ဆိုင်ရာ ဆရာ/ဆရာမမှ ပြန်လည်ဆက်သွယ်ပေးပါလိမ့်မည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Create Notification API Error", error);
                });
        },

        search(page = 1) {
            axios.get("my/course/list/filter?page=" + page, {
                params: {
                    keyword: this.keyword,
                    student_id: this.studentId
                }
            })
                .then((response) => {
                    this.classes = response.data;
                    this.classes.total = convertNumberService.convertEng2Mm(this.classes.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.classes.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.classes.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course Search API Error", error);
                });
        },

        getCourseEnrollStudentList(page = 1) {
            axios.get("/my/course/list?page=" + page, {
                params: {
                    student_id: this.studentId
                }
            })
                .then((response) => {
                    this.classes = response.data;
                    this.classes.total = convertNumberService.convertEng2Mm(this.classes.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.classes.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.classes.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Enroll Student Request API Error", error);
                });
        },
    },

    mounted() {
        const today = new Date();
        this.currentDate = today.toISOString().split("T")[0];
        this.getCourseEnrollStudentList();
        fetchNotificationCount();
    }
};
